export default __webpack_public_path__ + "static/media/frame1.78bc4569.png";